<template>
  <div class="store imgTOP-current header-90">
    <div  class="top-img">
      <img src="../assets/images/store.png" alt="" class="mobile_hide">
      <img src="../assets/images/storeM.png" alt=""  class="pc_hide">
      <div class="info-box">
        <div class="title-box">
          <h2>Store Information</h2>
          <h3>{{$t("home_5_0")}}</h3>
        </div>
      </div>
    </div>
    <div class="store-all">
      <div class="store-conten">
        <div class="store-title navigation">
          <router-link to="/home">{{$t("home_0")}}</router-link>
          <em>/</em>
          <span>{{$t('home_5_0')}}</span>
        </div>
        <div class="serch-main">
          <div class="serch-box">
            <div class="serch-stores-100">
              <div class="">
                <input type="text" v-model="searchValue" :placeholder="$t('store_1')">
                <span class="icon" @click="getData()"></span>
              </div>
              <em class="serch-stores-popup pc_hide" @click="showSearchPopup()"></em>
            </div>
            <div class="mobile-popup">
              <a class="close-btn pc_hide"  @click="closeSearchPopup()"></a>
              <div>
                <label>{{$t('store_2_0')}}</label>
                <div class="select-box select-01">
                  <vue-select2 :cityValue="cityValue" type="city"  :tip="$t('store_2')"  :list="cityData" @valueChanged="getSelectValue"></vue-select2>
                </div>
              </div>
              <div>
                <label>{{$t('store_3_0')}}</label>
                <div class="select-box select-02">
                  <vue-select2 :cityValue="areaValue" type="area" :tip="$t('store_3')" :list="areaData" @valueChanged="getSelectValue"></vue-select2>
                </div>
              </div>
              <div class="checkboxAll">
                <input type="checkbox" id="pol2" v-model="isSurfaceClass"><label for="pol2" class="checkboxText">{{$t('store_4')}}</label>
              </div>
             <div class="checkboxAll">
                <input type="checkbox" id="pol2" v-model="isQuickclick"><label for="pol2" class="checkboxText">{{$t('store_4_0')}}</label>
              </div>
              <div>
                <label>{{$t('store_5_0')}}</label>
                  <select-picker class="selectpicker"  multiple :dropdown-data="paymentDataStr" :placeholder="$t('store_5')" v-model="paymentStr" @change="changepPayment" />
              </div>
              <div>
                <label>{{$t('store_6_0')}}</label>
                  <select-picker class="selectpicker2"   multiple :dropdown-data="activityDataStr" :placeholder="$t('store_6')" v-model="activityStr" @change="changepPayment2" />
              </div>
              <div class="btnButton">
                <button @click="serchPage()">{{$t('store_7_0')}}<span></span></button>
              </div>
            </div>
          </div>
          <div class="serch-conten">
            <div class="search-content-box">
              <ul>
                <li v-for="(item,index) in data" :key="index">
                  <div class="stores-information">
                    <div class="img-top" v-if="item.surfaceClass == '有'"></div>
                    <div class="address">
                      <h5>{{item.name}}－外帶預約點餐</h5>
                      <div class="order-qrcode" v-if="item.quickClickUrl != null">
                       <img :src="item.quickClickUrlQrcode" class="mobile_hide"  style="max-width:100%;" ></div>
                      <div class="order-icon" v-if="item.quickClickUrl != null">
                        <a  :href="item.quickClickUrl" target="_blank"> </a>
                      </div>
                      <div class="address-icon">
                        <a  :href="item.url" target="_blank"> </a>
                      </div>
                      <p  v-if="item.quickClickUrl != null"><label><a  :href="item.quickClickUrl" target="_blank">{{item.name}}－{{$t('store_11')}}</a></label></p>

                      <p><label>{{$t('store_8')}} ：</label><span>{{item.address}}</span></p>
                      <p><label>{{$t('store_9')}} ：</label><span>{{item.telephone}}</span></p>
                      <p><label>{{$t('store_10')}} ：</label><span>{{item.businessHours}}</span></p>
                    </div>
                    <div class="pay-main" v-show="item.paymentMethodImageList.length!=0||item.activitysImageList.length!=0">
                      <div class="pay-box" v-show="item.paymentMethodImageList.length!=0">
                        <label  @click="payPopup(index)"  >{{$t('store_5_0')}}</label>
                        <div class="pay-Popup"  :class="{ 'mhide': !item.payShow }">
                          <div class="pay-conten-box">
                            <h5 class="pc_hide">{{$t('store_5_0')}}</h5>
                            <ul class="pay-ul">
                              <li v-for="(item2,index2) in item.paymentMethodImageList" :key="index2">
                                <div class="pay-img">
                                  <img :src="item2.imageUrl" width="60">
                                </div>
                                <div class="hover-box mobile_hide">{{item2.name}}</div>
                                <div class="hover-box-2 pc_hide">{{item2.name}}</div>
                              </li>
                            </ul>
                            <div class="popup-btn pc_hide">
                              <a  @click="closePayPopup(index)">返回</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="activity pay-box" v-show="item.activitysImageList.length!=0">
                        <label @click="activityPopup(index)" >{{$t('store_6_1')}}</label>
                        <div class="activity-Popup " :class="{ 'mhide': !item.activityShow }">
                          <div class="pay-conten-box">
                            <h5 class="pc_hide">{{$t('store_6_1')}}</h5>
                            <ul class="activity-ul">
                              <li v-for="(item2,index2) in item.activitysImageList" :key="index2">
                                <div class="activity-img">
                                  <img :src="item2.imageUrl" alt="">
                                </div>
                                <div class="activity-text">{{item2.name}}</div>
                              </li>
                            </ul>
                            <div class="popup-btn pc_hide">
                              <a  @click="closeActivityPopup(index)">返回</a>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>

                  </div>
                </li>
              </ul>

              <my-page :totalPage="totalPage" @changepage="changepage"></my-page>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from "./config/api.js";
  import Page from './default/Page.vue';
  import VueSelect2 from './default/vue-select2'
  export default {
    name: 'Store',
    data () {
      return {
        cityData:[],
        areaData:[],
        //搜索條件
        searchValue:"",
        cityValue:"",
        areaValue:"",
        isSurfaceClass: false,
        isQuickclick:false,
        quickClickUrl:"",
        quickClickUrlQrcode:"",
        paymentData: [],
        paymentDataStr:[],
        payment: '',
        paymentStr: [],
        activity: "",
        vals:'',
        activityStr: [],
        activityData: [],
        activityDataStr: [],
        //page
        data: [],
        pageIndex:1, //當前頁數
        pageSize:30, //每页显示条数
        totalPage: 0 //總頁數

      }
    },
    created(){
      this.searchValue = this.$route.query.searchValue;
      this.cityValue = this.$route.query.cityValue;
      this.areaValue = this.$route.query.areaValue;
      this.vals = this.$route.query.cityValue;
      this.GetCity();
      this.GetPaymentList();
      this.GetActivitysList();
      this.getData();
    },
    mounted(){
      $('.mobile-popup').addClass('mhide');
    },
    metaInfo() {
      const baseUrl = 'https://www.8way.com.tw';
      const ogTitle = '八方雲集 - 門市查詢 | 找到离您最近的門市';
      const ogDescription = '查詢八方雲集全台門市位置、營業時間、聯絡電話及服務資訊，輕鬆找到离您最近的八方雲集餐廳。';
      const ogImage = 'https://www.8way.com.tw/assets/images/ogImg_home.jpg';

      const storePageSchema = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "@id": `${baseUrl}/store#collection`,
        "url": `${baseUrl}/store`,
        "name": "八方雲集門市據點",
        "description": "查詢全台八方雲集門市據點,提供地址、電話、營業時間與線上點餐服務,目前全台共有 1002 家門市為您服務。",
        "inLanguage": "zh-TW",
        "isPartOf": {
          "@id": `${baseUrl}/#website`
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "首頁",
              "item": `${baseUrl}/`
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "門市據點",
              "item": `${baseUrl}/store`
            }
          ]
        },
        "mainEntity": {
          "@type": "ItemList",
          "name": "八方雲集門市列表",
          "numberOfItems": 1002,
          "itemListOrder": "https://schema.org/ItemListUnordered"
        }
      };

      return {
        title: '八方雲集線上訂餐｜全台門市查詢與外帶自取',
        meta: [
                  //  SEO 用（搜尋引擎）
          {
            name: "description",
            content: '八方雲集線上訂餐與全台門市查詢，提供各門市地址、電話與營業時間，線上點餐外帶自取免排隊，部分門市提供外送服務，讓您不論外帶或在家都能享受安心美味'
          },
          { property: 'og:title', content: ogTitle },
          { property: 'og:description', content: ogDescription },
          { property: 'og:image', content: ogImage },
          { property: 'og:url', content: baseUrl + '/store' },
          { property: 'og:type', content: 'website' }
        ],
        script: [
          {
            type: 'application/ld+json',
            json: storePageSchema
          }
        ]
      };
    },

    methods:{
      changepPayment(data, text) {
        this.paymentStr = data.data;
      },
      changepPayment2(data, text) {
        this.activityStr = data.data;
      },
      //獲取數據
      getData(){
        let payment = [];
        for(let i=0;i<this.paymentData.length;i++){
          for(let j=0;j<this.paymentStr.length;j++) {
            if(this.paymentStr[j] == this.paymentData[i].name) {
              payment.push(this.paymentData[i].code);
              break;
            }
          }
        }
        /*this.payment = payment.join(',');*/
        this.payment = payment;
        let activity = [];
        for(let i=0;i<this.activityData.length;i++){
          for(let j=0;j<this.activityStr.length;j++) {
            if(this.activityStr[j] == this.activityData[i].name) {
              activity.push(this.activityData[i].name);
              break;
            }
          }
        }
        this.activity = activity;

        this.$store.commit('showLoading');
        this.$post(API.GetWebShopList,{
          "keyword": this.searchValue,
          "city": this.cityValue,
          "area": this.areaValue,
          "isSurfaceClass": this.isSurfaceClass,
          "isQuickclick": this.isQuickclick,
          "paymentId": this.payment,
          "activityName": this.activity,
          "pageIndex": this.pageIndex,
          "pageSize": this.pageSize
        }).then((response) => {
          this.$store.commit('hideLoading');
          if(response.code == 200){
            this.data = response.data.dataList;
            this.totalPage = Math.ceil(response.data.totalCount/this.pageSize);
          }
        });
      },
      //獲取城市
      GetCity:function(){
        this.$fetch(API.GetCityList).then((response) => {
          if(response.code == 200){
          this.cityData = response.data;
          if(this.$route.query.cityValue){
            this.GetArea(this.$route.query.cityValue);
          }else {
            this.GetArea();
          }
        }
      });
      },
      //獲取地區
      GetArea:function(val){
        this.$post(API.GetAreaList+val || this.cityValue).then((response) => {
          if(response.code == 200){
          this.areaData = response.data;
          if(this.$route.query.cityValue){
            this.areaValue = this.$route.query.areaValue;
          }
        }
      });
      },
      //獲取支付方式
      GetPaymentList:function(){
        this.$fetch(API.GetPaymentList).then((response) => {
          if(response.code == 200){
          this.paymentData = response.data;
          for(let i=0;i<this.paymentData.length;i++){
            this.paymentDataStr.push(this.paymentData[i].name);
          }
        }
      });
      },
      //獲取活動
      GetActivitysList:function(){
        this.$fetch(API.GetActivitysList).then((response) => {
          if(response.code == 200){
          this.activityData = response.data;
          for(let i=0;i<this.activityData.length;i++){
            this.activityDataStr.push(this.activityData[i].name);
          }
        }
      });
      },
      getSelectValue(value){
        if(value.type == 'city'){
          this.cityValue = value.currentValue;
          this.areaValue = '';
          this.GetArea(this.cityValue);
        }else if(value.type == 'area'){
          this.areaValue = value.currentValue;
        }
      },
      //分頁
      changepage(currentPage){
        this.pageIndex = currentPage;
        this.getData();
      },
      //搜索重置分页
      serchPage(){
        this.pageIndex =1;
        this.getData();
        this.closeSearchPopup();
      },
      /*搜索彈窗*/
      showSearchPopup(){
        $('.mobile-popup').removeClass('mhide');
        $('body').addClass('no-scroll');
      },
      closeSearchPopup(){
        $('.mobile-popup').addClass('mhide');
        $('body').removeClass('no-scroll');
      },
      /*支付方式彈窗*/
      payPopup(i){
        $('body').addClass('no-scroll');
        this.data[i].payShow=true;
        this.$forceUpdate()
      },
      closePayPopup(i){
        $('body').removeClass('no-scroll');
        this.data[i].payShow=false;
        this.$forceUpdate()

      },
      activityPopup(i){
        $('body').addClass('no-scroll');
        this.data[i].activityShow=true;
        this.$forceUpdate()
      },
      closeActivityPopup(i){
        $('body').removeClass('no-scroll');
        this.data[i].activityShow=false;
        this.$forceUpdate()
      },

    },
    components:{
      'my-page': Page,
      'vue-select2': VueSelect2
    },
    watch: {
//      paymentDataStr:function() {
//          $('.selectpicker').selectpicker('refresh');
//          $('.selectpicker').selectpicker('render');
//      },
//      activityDataStr:function() {
//          $('.selectpicker2').selectpicker('refresh');
//          $('.selectpicker2').selectpicker('render');
//      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .pay-box{
  label{
    min-width: 75px;
    float:left;
    margin-right:5px;
  }
  ul{
    width:100%;
    height: auto;
    padding-left:80px;
    li{
      margin-bottom: 6px;
    }
  }
  .pay-ul{

    height: 40px;
    padding:0;
    margin-bottom:8px;
  li{

    list-style: none;
    float:left;
    box-shadow: none;
    position:relative;
  img{
    width:auto ;
    height: 32px;
    background-size: 100%;
    vertical-align: top;
  }
  .hover-box{
    width: 100%;
    min-width: 80px;
    height: auto;
    font-size:16px;
    color:#fff;
      padding:4px;
    background: #000;
    border-radius:4px;
    position: absolute;
    top:-36px;
    left:50%;
    display: none;
    text-align: center;
    transform: translate(-50%, -30%);
    -webkit-transform: translate(-50%, -30%);
    -moz-transform: translate(-50%, -30%);
  &:after{
     content:'';
     width: 0;
     height: 0;
     border-left: 5px solid transparent;
     border-right: 5px solid transparent;
     border-top: 8px solid #000;
     position: absolute;
     bottom: -8px;
     left: 47%;
   }
  }
  &:hover .hover-box{
     display: block;
   }
  }
  }
  }
  .store{
    width: 100%;
    height:auto;
/*  .top-img{
    width: 100%;
    height: 354px;
    position: relative;
    background: #f9f9f9 url("../assets/images/store.png") no-repeat center;
    background-size: 100% 100%;
       .bg-img{
         position: absolute;
         width: 100%;
       }
  .info-box{
    width: 100%;
    max-width: 1300px;
    padding: 0 20px;
    margin: 0 auto;
  .title-box{
    float: left;
    padding-top: 60px;
    text-align: right;
    margin-left:7%;
  h2{
    color: #FFFFFF;
    font-size: 70px;
    font-style: italic;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 120px;
    margin: 0;
  }
  h3{
    color: #FFFFFF;
    font-size: 36px;
    letter-spacing: 1px;
    line-height: 42px;
    margin: 0;
  }
  }
  }
  }*/
  .store-all{
    width: 100%;
    height: 100%;
    background: #f9f9f9 url("../assets/images/store-contenBg.png") no-repeat center 82px;
    background-size: 100%;
    margin:auto;
    padding-bottom:180px;
    padding-top:50px;
  .store-conten{
    max-width: 1400px;
    height: auto;
    margin-left: 269px;
  }
/*  .store-title{
    font-size: 14px;
    letter-spacing: 1.5px;
     a{
       color: #000;
       text-decoration: underline;
     }
     em{
       padding: 0 4px;
     }
  span,em{
    color: #9A928D;
  }
  }*/
  .serch-main{
    margin-top:53px;
  .serch-box{
    box-sizing: border-box;
    height:auto;
    width: 25%;
    border: 3px solid rgba(151,151,151,0.05);
    border-radius: 20px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    padding: 67px 26px 78px 26px;
    display: inline-block;
     div{
       margin-bottom:32px;
          input[type='text'],select{
            width: 100%;
            height: 55px;
            border: 1px solid #908782;
            border-radius: 35px;
            background-color: #FFFFFF;
            padding:0 28px;
            letter-spacing: 1.5px;
          }
          label{
            color: #000000;
            font-size: 20px;
            font-weight: 500;
            display: block;
            margin-bottom: 10px;
            letter-spacing: 1.5px;
          }
         .checkboxText{
           color: #000000;
           font-size: 16px;
           display: inline-block;
           font-weight: normal;
           vertical-align: top;
           margin-left: 12px;
           letter-spacing: 1.2px;
         }
         &:last-child{
          margin-bottom: 0;
          }
     }
     .select-box{
       height: 55px;
       line-height: 55px;
       position: relative;
      .vue-select .option-box{
        padding-top: 35px;
      }
     }
    .select-01{
      z-index: 2;
    }
    .select-02{
      z-index: 1;
    }
    .checkboxAll{
      margin-bottom: 22px;
    }
  .btnButton{
    width: 70%;
    margin: auto;
    font-weight: bold;
    position: relative;
  span{
    width: 37px;
    height: 36px;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top:-18px;
    background: url(../assets/images/search-nextIcon.svg) no-repeat right center;
  }
  }
  }

  .serch-conten{
    width: calc(100% - 26% );
    height: auto;
    display: inline-block;
    vertical-align: top;
  .search-content-box{
    padding-left:91px;
  &>ul{
      padding:0;
  &>li{
      width:100%;
      height: auto;
      background-color: #FFFFFF;
      box-sizing: border-box;
      border-radius: 20px;
      background-color: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
      margin-bottom:30px;
      overflow: hidden;
  .stores-information{
    position: relative;
    padding:20px 44px;
     .img-top{
       width: 140px;
       height: 125px;
       background: url("../assets/images/information-top.png") no-repeat top;
       position: absolute;
       top:0;
       left: 0;
       background-size: 100%;
     }
       label{
         color: #2A1C15;
         font-weight: 500;
         margin-bottom:0;
         font-size: 17px;
         letter-spacing: 1.59px;
         padding-top: 5px;
       }
  .address{
    width: calc(100% - 110px );
    float: right;
    padding-bottom:26px;
       h5{
         color: #424242;
         font-size: 24px;
         font-weight: 500;
         padding-bottom:29px;
         display: inline-block;
         letter-spacing: 1.8px;
         margin-bottom: 0;
       }
  .address-icon{
    height: 52px;
    width: 52px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 7px 0 rgba(0,0,0,0.09);
    border-radius: 50%;
    float: right;
    line-height: 52px;
    text-align: center;
    position: absolute;
    top:22px;
    right:27px;
      a{
        height: 33px;
        width: 25px;
        display: inline-block;
        background: url(../assets/images/address-icon-red.svg) no-repeat center;
        background-size: 100%;
        vertical-align: middle;
        margin-top: -6px;
      }
  }
   p{
       font-size: 17px;
       letter-spacing: 1.27px;
       margin-bottom:8px;
          span{
            color: #2A1C15;
          }
          &:last-child{
             margin-bottom:0;
           }
     }
    .order-icon{
    height: 52px;
    width: 52px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 7px 0 rgba(0,0,0,0.09);
    border-radius: 50%;
    float: right;
    line-height: 52px;
    text-align: center;
    position: absolute;
    top:22px;
    right:87px;
      a{
        height: 33px;
        width: 25px;
        display: inline-block;
        background: url(../assets/images/cart-icon.svg) no-repeat center;
        background-size: 100%;
        vertical-align: middle;
        margin-top: -6px;
      }
  }
    .order-qrcode{
    height: 100px;
    width: 100px;

    border-radius: 50%;
    float: right;
    line-height: 52px;
    text-align: center;
    position: absolute;
    top:22px;
    right:237px;
      a{
        height: 33px;
        width: 25px;
        display: inline-block;

        vertical-align: middle;
        margin-top: -6px;
      }
  }
  }
     .pay-main{
       width: 100%;
       height: auto;
       border-top: 2px solid #f5f5f5;
       padding-top: 18px;
       clear: both;
        .pay-box{
          width: calc(100% - 110px);
          margin-left: 110px;
           div{
               input,select{
                 height: 50px;
               }
           }
        }
     }
  }
    &:last-child{
     margin-bottom: 20px;
   }
  }
  }
  }
  }
  }
  }
  }
  .activity{
    width: 100%;
    height: auto;
    clear: both;
    overflow: hidden;
       ul{
            li{
             display: inline-block;
              padding-right:4px;
                 img{
                   width: 33px;
                   height: 100%;
                   display: inline-block;
                   vertical-align: middle;
                 }
                 div{
                   color: #342112;
                   font-size: 16px;
                   display: inline-block;
                   letter-spacing: 1.2px;
                 }
            }
       }
  }
  .serch-stores-100{
    position: relative;
    width:100%;
     .icon{
       width: 20px;
       height: 100%;
       background: url(../assets/images/searchIcon.svg) no-repeat right center;
       position: absolute;
       right: 28px;
       top: 0px;
       background-size: 100%;
       cursor: pointer;
     }
  }
  @media (max-width:1760px){
    .store .store-all .store-conten{
      margin-left: 0;
      margin: auto;

    }
  }
  @media (max-width:1560px){
    .store .store-all .store-conten{
      margin: 0 50px;
    }
  }

  @media (max-width:1080px){
/*    .store  .top-img{
      height: 168px;
      background: url("../assets/images/storeM.png") no-repeat center;
      background-size: 100%;
    .info-box{
      max-width: 100%;
    .title-box{
      width: 100%;
      margin-left:0;
    h2{
      font-size: 26px;
      line-height: 1.2;
    }
    h3{
      font-size: 20px;
    }
  }
  }
  }*/

  .store .store-all {
    padding:20px;
    background: #f9f9f9 url("../assets/images/product-contenBg.png") no-repeat center top;
    background-size:100%;
     .store-conten{
       margin: 0;
     }
  .store-conten,.serch-main .serch-box,.serch-main .serch-conten{
    width: 100%;
  }


  .serch-main{
  .serch-conten .search-content-box{
    padding-left: 0;
  }
  .serch-conten .search-content-box>ul{
    margin-bottom: 31px;
    li{
     margin-bottom: 20px;
    }
  }
  .serch-conten .search-content-box>ul>li .stores-information{
    padding:0 12px;
    padding-bottom:20px;
  .img-top{
    width: 78px;
    height: 73px;
  }
  .pay-main{
    padding: 0 14px;
     padding-top: 10px;
  }
  .address{
    width: 100%;
    padding-bottom:18px;
    padding-top:77px;
    position:relative;
    padding-left:14px;
  p{
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 4px;
    letter-spacing: 0.5px;
    label{
      font-size: 14px;
    }
  }
  h5{
    position: absolute;
    top:26px;
    left: 38%;
    font-size: 18px;
    letter-spacing: 1.35px;
  }
  .address-icon{
    height: 36px;
    width: 36px;
    position: absolute;
    right: 2px;
    top: 15px;
    a{
      height: 23px;
      width: 17px;
      margin-top: -15px;
    }
  }
   .order-icon{
    height: 36px;
    width: 36px;
    position: absolute;
    right: 40px;
    top: 15px;
    a{
      height: 23px;
      width: 17px;
      margin-top: -15px;
    }
  }
   .order-qrcode{
    height: 36px;
    width: 36px;
    position: absolute;
    right: 100px;
    top: 60px;
    a{
      height: 23px;
      width: 17px;
      margin-top: -15px;
    }
  }
  }

  .pay-main .pay-box{
    border-radius: 35px;
    background-color: #F5AC2D;
    width: 40%;
    height: 40px;
    line-height: 40px;
    margin-left: 0;
    display: inline-block;
    text-align: center;
    vertical-align: top;
  label{
    float: none;
    color: #2A1C15;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.44px;
    padding-top: 0;
    display: block;
  }
  &.activity{
     float: right;
   }
  .pay-Popup,.activity-Popup{
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(255,255,255,0.5);
    padding:0 20px;
    top: 0;
    left:0;
    z-index: 9;
    padding-top: 67px;
       h5{
         color: #424242;
         font-size: 18px;
         font-weight: 500;
         text-align: center;
         padding-bottom:0;
         letter-spacing: 1.35px;
       }
  .pay-conten-box{
    width: 100%;
    height: auto;
    border-radius: 20px;
    background-color: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.15);
    overflow: hidden;
    margin-top: 20%;
    padding:27px 13px 34px;
     ul{
       width: 100%;
       height: auto;
       overflow: hidden;
       padding-left: 0;
     }
        li{
          width: 100%;
          border-bottom: 1px solid #efefef;
          float:none;
          text-align: left;
          padding:0 12px;
          margin-bottom:0;
            &:last-child{
               border-bottom:0;
             }
             img{
               display: inline-block;
               width: auto;
               height: 25px;
               background-size: 100%;
               vertical-align: middle;
             }
               div{
                 width:calc(100% - 82px);
                 display: inline-block;
                 background: none;
                 position: inherit;
                 top: 0;
                 left:0;
                 color: #2A1C15;
                 font-size: 15px;
                 text-align: left;
                 margin-left: 0;
                 letter-spacing: 1.13px;
               &:after{
                  content: inherit;
                }
               }
                .activity-img{
                  width: 35px;
                }
               .pay-img{
                 width: 82px;
               }
               .hover-box-2{
                 display: inline;
               }
               .activity-text{
                 width:calc(100% - 40px);
               }
        }
  }
  .popup-btn{
    height: 45px;
    width: 220px;
    border-radius: 35px;
    line-height: 45px;
    background-color: #F5AC2D;
    margin: auto;
    margin-top: 16px;
     a{
       width: 100%;
       display: inline-block;
       letter-spacing: 1.2px;
       font-size: 16px;
       color: #1C2024;
       font-weight: 500;
     }

  }
  }

  }
  }

     .serch-box{
       background: none;
       box-shadow: none;
       border: 0;
       padding: 0;
        div{
         margin-bottom:30px;
           input[type='text']{
             height: 50px;
             border:0;
             box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
           }
        }
       .select-box{
         height: 50px;
       }
        div select{
          height: 45px;
        }
        .btnButton{
          width: 100%;
          margin-top:74px;
        }
     }
  }
  }
  .mobile-popup{
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(255,255,255,0.95);
    padding: 32px 38px;
    top: 0;
    left:0;
    z-index: 1002;
    padding-top: 67px;
    padding-bottom: 75px;
    overflow: auto;
  .close-btn{
    width: 22px;
    height: 22px;
    background: url('../assets/images/Icon_Home_Menu_Back@2x.png') no-repeat center center;
    background-size: 100%;
    display: block;
    position: absolute;
    right:20px;
    top:20px;
  }
  div{
  label{
    color: #261A16 !important;
    font-size: 15px !important;
    font-weight: normal !important;
    letter-spacing: 0.83px !important;
  }
  }
  }

  .serch-stores-100{
    position: relative;
    width:100%;
  div{
    position: relative;
    width:85%;
  }
  }
  .serch-stores-popup{
    height: 36px;
    line-height: 36px;
    width: 36px;
    border-radius: 18px;
    display: inline-block;
    background:#CF0902 url(../assets/images/serchPopup.svg) no-repeat center center;
    position: absolute;
    right: 0;
    top: 10px;
  }

  .store .store-all .serch-main{
    padding: 0;
    margin-top: 42px;
  }

  }

</style>



// WEBPACK FOOTER //
// src/components/store.vue